import {
  Box, Skeleton,
  useTheme,
} from '@mui/material';

export default function AccountInformationSkeleton() {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          width: theme.spacing(64),
        }}
      >
        <Skeleton
          sx={() => ({
            borderRadius: theme.spacing(1.625),
            marginBottom: 2,
            height: 132,
          })}
          animation="wave" variant="rectangular" />
        <Skeleton
          sx={() => ({
            borderRadius: theme.spacing(1.625),
            marginBottom: 2,
            height: 50,
          })}
          animation="wave" variant="rectangular" />
      </Box>
    </>
  );
}
